const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/appointment/components/AppoinmentButtonsRow.tsx';
import Grid from '@mui/material/Grid';
import * as React from 'react';
import { css, cx } from '@emotion/css';

const buttonMarginCSS = css`
    & > * {
        margin-right: 16px;
    }
`;

type AppoinmentButtonsRowProps = {
    children: React.ReactNode;
    className?: string;
};

export const AppoinmentButtonsRow = (props: AppoinmentButtonsRowProps) => {
    return (
        <Grid size={{ xs: 12 }} className={cx(props.className, buttonMarginCSS)}>
            {props.children}
        </Grid>
    );
};
